import FileUpload from "components/FileUpload";
import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import { FC, useEffect, useState } from "react";
import { addChangeOfVuenue, editChangeOfVenue } from "services/caseServices";
import { CaseCreation, ChangeOfVenue } from "types";
import { LoadingIcon } from "utils/constant";
import { errorHandler, errorHandlerOnForm } from "utils/helper";

type Props = {
  caseData?: CaseCreation;
  venue?: ChangeOfVenue;
  onClose: (refetch: boolean) => void;
};

const ChangeOfVenueForm: FC<Props> = ({ caseData, venue, onClose }) => {
  const { loginData } = useAuth();
  const { showTooltip } = useTooltip();
  const [loading, setLoading] = useState(false);

  const [formState, setFormState] = useState<ChangeOfVenue>({});

  useEffect(() => {
    if (venue) {
      setFormState({
        ...venue,
      });
    }
  }, [venue]);

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose(false);
    }
  };

  const handleFile = (file: File | null) => {
    setFormState((prev) => ({ ...prev, summary_file: file }));
  };

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-[600px]">
        <h2 className="text-lg font-semibold text-gray-800">Change of Venue</h2>
        <p className="text-xs text-gray-500 mb-4">
          Please fill in the details for the change of venue request.
        </p>

        <div className="grid grid-cols-2 gap-4 mt-4">
          <div className="flex flex-col mt-4 w-full">
            <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
              Date
            </label>
            <input
              type="date"
              className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
              value={
                formState?.date
                  ? new Date(formState.date).toISOString().split("T")[0]
                  : ""
              }
              onChange={(e) =>
                setFormState((prev) => ({
                  ...prev,
                  date: e.target.value ? new Date(e.target.value) : undefined,
                }))
              }
            />
          </div>
          {/* <div className="flex flex-col mt-4 w-full">
            <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
              Prosecution Case Number
            </label>
            <input
              type="text"
              placeholder="Enter prosecution case number"
              className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
              value={formState.prosecution_case_number || ""}
              onChange={(e) =>
                setFormState((prev) => ({
                  ...prev,
                  prosecution_case_number: e.target.value,
                }))
              }
            />
          </div> */}
          {/* <div className="flex flex-col mt-4 w-full">
            <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
              Court Case Number
            </label>
            <input
              type="text"
              placeholder="Enter court case number"
              className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
              value={formState.court_case_number || ""}
              onChange={(e) =>
                setFormState((prev) => ({
                  ...prev,
                  court_case_number: e.target.value,
                }))
              }
            />
          </div> */}
          <div className="flex flex-col mt-4 w-full">
            <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
              Registration Number
            </label>
            <input
              type="text"
              placeholder="Enter registration number"
              className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
              value={formState.registration_number || ""}
              onChange={(e) =>
                setFormState((prev) => ({
                  ...prev,
                  registration_number: e.target.value,
                }))
              }
            />
          </div>
        </div>
        <div className="flex flex-col mt-2 w-full">
          <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
            Reason Summary
          </label>
          <textarea
            rows={4}
            placeholder="Enter reason summary."
            className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
            value={formState.reason_summary || ""}
            onChange={(e) =>
              setFormState((prev) => ({
                ...prev,
                reason_summary: e.target.value,
              }))
            }
          />
        </div>
        <div className="mt-4">
          <FileUpload
            label="Summary File"
            fileTypes="*"
            info="Upload Files"
            required={false}
            onChange={handleFile}
          />
        </div>

        <div className="mt-4 flex justify-between gap-2">
          <button
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded w-full hover:bg-gray-300"
            onClick={() => {
              onClose(false);
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`border border-[#E90101] bg-[#E90101] px-10 py-2 text-white 
                        font-[Poppins] cursor-pointer font-[500] w-full
                        text-base rounded-md hover:bg-white hover:text-[#E90101]
                        ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
            disabled={loading}
            onClick={() => {
              setLoading(true);
              const api = venue ? editChangeOfVenue : addChangeOfVuenue;
              api({
                id: venue ? venue?.id : caseData?.id,
                summary_file: formState.summary_file,
                reason_summary: formState.reason_summary,
                date: formState.date
                  ? typeof formState.date === "string"
                    ? formState.date
                    : new Date(formState.date).toISOString().split("T")[0]
                  : undefined,
                prosecution_case_number:
                  caseData?.prosecutor_registration_number,
                court_case_number:
                  caseData?.opening_case_files &&
                  caseData?.opening_case_files[0]?.court_registration_number,
                registration_number: formState.registration_number,
                case: venue?.case || caseData?.id,
                incident_registration_number:
                  venue?.incident_registration_number ||
                  caseData?.incident_registration_no,
                crime_registration_number:
                  venue?.crime_registration_number ||
                  caseData?.crime_refernce_number,
                status: "pending",
                uploaded_by: loginData?.full_name,
              })
                .then(() => {
                  setLoading(false);
                  showTooltip(
                    "Change of Venue Submitted Successfully!",
                    "success"
                  );
                  onClose(true);
                })
                .catch((error) => {
                  setLoading(false);
                  showTooltip(
                    error?.response?.data?.detail ||
                      errorHandlerOnForm(error) ||
                      errorHandler(error) ||
                      "Something went wrong. Please try again.",
                    "error"
                  );
                });
            }}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                {LoadingIcon}
                Loading...
              </div>
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangeOfVenueForm;
